import { render, staticRenderFns } from "./GroupsV2.vue?vue&type=template&id=6786ff04&scoped=true&"
import script from "./GroupsV2.vue?vue&type=script&lang=js&"
export * from "./GroupsV2.vue?vue&type=script&lang=js&"
import style0 from "./GroupsV2.vue?vue&type=style&index=0&id=6786ff04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786ff04",
  null
  
)

export default component.exports